/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type { ServiceUpdateModalWithoutProjectContext as ServiceUpdateModalWithProjectContextType } from '@jira/spa-apps__servicedesk-service-update-modal-without-project-context/src/ServiceUpdateModalWithoutProjectContext.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServiceUpdateModalWithProjectContext: LazyComponent<
	() => React.JSX.Element | null
> = lazyForPaint<typeof ServiceUpdateModalWithProjectContextType>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-service-update-modal-without-project-context", jiraSpaEntry: "async-servicedesk-service-update-modal-without-project-context" */ '@jira/spa-apps__servicedesk-service-update-modal-without-project-context/src/ServicedeskServiceUpdateModalWithoutProjectContext.tsx'
		),
);

const AsyncServiceUpdateModalWithProjectContext = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServiceUpdateModalWithProjectContext}
		pageId="spa-apps/servicedesk/service-update-modal"
		shouldShowSpinner
	/>
);

export default AsyncServiceUpdateModalWithProjectContext;
